import { render } from "./donePage.vue?vue&type=template&id=cc482228"
import script from "./donePage.vue?vue&type=script&lang=js"
export * from "./donePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__